import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

export interface SectionTranslationFields {
  name: string;
}

export type SectionTranslationsMap = Record<string, SectionTranslationFields>;

@Injectable({providedIn: 'root'})
export class SectionContentTranslationService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {}

  async getAll(sectionId: string): Promise<SectionTranslationsMap> {
    const url = `${this.toolsSrv.getApiTargetEndpoint()}i18n/section/${sectionId}`;
    return await this.http.get<SectionTranslationsMap>(url).toPromise() ?? {};
  }

  async update(sectionId: string, langSrc: string, field: 'name', value: string): Promise<void> {
    const url = `${this.toolsSrv.getApiTargetEndpoint()}i18n/section/${sectionId}`;
    await this.http.patch(url, {langSrc, field, value}).toPromise();
  }
}
